<template>
  <div id="app">
    <app-header
      app-title="Bulk Collection"
      app-subtitle="Bulk Pickup Online Form"
      :appLink="appLink"
    >
      <mobile-nav slot="mobile-nav">
        <ul>
          <li>
            <a
              href="https://www.phila.gov/departments/department-of-sanitation/"
              target="_blank"
              >Department of Sanitation</a
            >
          </li>
          <li>
            <a href="https://www.phila.gov/terms-of-use/" target="_blank"
              >Terms of Use</a
            >
          </li>
          <li>
            <a href="mailto:sanitation@phila.gov">Provide Feedback</a>
          </li>
          <li>
            <a href="https://www.phila.gov/privacypolicy/" target="_blank"
              >Privacy Policy</a
            >
          </li>
        </ul>
      </mobile-nav>
    </app-header>
    <main class="container is-4">
      <div class="columns is-multiline is-12">
        <div class="column is-3"></div>
        <div class="column is-12"><router-view /></div>
      </div>
    </main>

    <app-footer :links="footerLinks"> </app-footer>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      appLink: process.env.VUE_APP_BASE_URL,
      footerLinks: [
        {
          text: "Department of Sanitation", //the route name is used, and not the path
          href: "https://www.phila.gov/departments/department-of-sanitation/", //the route name is used, and not the path
          type: "native", //any other html anchor attributes
          attrs: { target: "_blank" },
        },
        {
          text: "Provide Feedback", //the route name is used, and not the path
          href: "mailto:sanitation@phila.gov", //the route name is used, and not the path
          type: "native", //any other html anchor attributes
          attrs: { target: "_blank" },
        },
        {
          text: "Terms of Use", //the route name is used, and not the path
          href: "https://www.phila.gov/terms-of-use/", //the route name is used, and not the path
          type: "native", //any other html anchor attributes
          attrs: { target: "_blank" },
        },
        {
          text: "Privacy Policy", //the route name is used, and not the path
          href: "https://www.phila.gov/privacypolicy/", //the route name is used, and not the path
          type: "native", //any other html anchor attributes
          attrs: { target: "_blank" },
        },
      ],
    };
  },
  /**
   * Lifecycle hook called before the component is mounted.
   * Clears the local storage and logs the current date and time.
   */
  beforeMount() {
    console.log("Clearing local storage", new Date());
  },

  methods: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
</style>
